module.exports = __webpack_public_path__ + "static/media/github.4be03093.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/github.png
// module id = 402
// module chunks = 0